import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import Funding from '@/views/Funding'
import RequestDetail from '@/views/RequestDetail'
import DashboardInvestment from '@/views/DashboardInvestment'
import DashboardVirtualAccount from '@/views/DashboardVirtualAccount'
import InvestorClabe from '@/views/InvestorClabe'
import UserProfile from '@/views/UserProfile'
import LogIn from '@/views/LogIn'
import SignUp from '@/views/SignUp'
import VerifyEmail from '@/views/VerifyEmail'
import ResetPassword from '@/views/ResetPassword'
import PageNotFound from '@/components/PageNotFound'
import Commissions from '@/views/Commissions'
import ComingSoon from '@/components/ComingSoon'
import InvestorPerformance from '@/views/InvestorPerformance'

// import store from '@/store'
import isLogged from '@/middleware/isLogged'
import requireAuth from '@/middleware/requireAuth'

Vue.use(Router)
Vue.use(Meta)

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
// https://github.com/vuejs/vue-router-demos/blob/master/examples/scroll-behavior/index.js

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  } else {
    const position = {}
    if (to.hash) {
      position.selector = to.hash
    }
    if (to.matched.some(m => m.meta.scrollToTop)) {
      position.x = 0
      position.y = 0
    }
    return position
  }
}

const routeInMaintenance = [
  {
    path: '/*',
    name: 'ComingSoon',
    component: ComingSoon,
    meta: {
      scrollToTop: true
    }
  }
]

const routesReal = [
  {
    path: '/',
    name: 'Home',
    component: DashboardInvestment,
    meta: {
      scrollToTop: true,
      middleware: [isLogged, requireAuth]
    }
  },
  {
    path: '/financiamiento',
    name: 'Funding',
    component: Funding,
    meta: {
      scrollToTop: true,
      middleware: [isLogged]
    }
  },
  {
    path: '/solicitud/:market/:id',
    name: 'RequestDetail',
    component: RequestDetail,
    meta: {
      scrollToTop: true,
      middleware: [isLogged, requireAuth]
    }
  },
  {
    path: '/dashboard/inversiones',
    name: 'DashboardInvestment',
    component: DashboardInvestment,
    meta: {
      scrollToTop: true,
      middleware: [isLogged, requireAuth]
    }
  },
  {
    path: '/dashboard/cuenta-virtual',
    name: 'DashboardVirtualAccount',
    component: DashboardVirtualAccount,
    meta: {
      scrollToTop: true,
      middleware: [isLogged, requireAuth]
    }
  },
  {
    path: '/dashboard/clabe',
    name: 'InvestorClabe',
    component: InvestorClabe,
    meta: {
      scrollToTop: true,
      middleware: [isLogged, requireAuth]
    }
  },
  {
    path: '/dashboard/perfil',
    name: 'UserProfile',
    component: UserProfile,
    meta: {
      scrollToTop: true,
      middleware: [isLogged, requireAuth]
    }
  },
  {
    path: '/login',
    name: 'LogIn',
    component: LogIn,
    meta: {
      scrollToTop: true,
      middleware: [isLogged]
    }
  },
  {
    path: '/signup/:id?',
    name: 'SignUp',
    component: SignUp,
    meta: {
      scrollToTop: true,
      middleware: [isLogged]
    }
  },
  {
    path: '/verificar/:token',
    name: 'VerifyEmail',
    component: VerifyEmail,
    meta: {
      scrollToTop: true,
      middleware: [isLogged]
    }
  },
  {
    path: '/restaurar-clave/:token',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      scrollToTop: true,
      middleware: [isLogged]
    }
  },
  {
    path: '/commissions',
    name: 'Commissions',
    component: Commissions,
    meta: {
      scrollToTop: true,
      middleware: [isLogged]
    }
  },
  {
    path: '/dashboard/rendimientos',
    name: 'InvestorPerformance',
    component: InvestorPerformance,
    meta: {
      scrollToTop: true,
      middleware: [isLogged, requireAuth]
    }
  },
  {
    path: '*',
    component: PageNotFound
  }
]

const routes = process.env.COMING_SOON === 'true'
  ? routeInMaintenance
  : routesReal

const router = new Router({
  scrollBehavior,
  mode: 'history',
  routes
})

function nextFactory (context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    context.next(...parameters)
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]

    const context = {from, next, router, to}
    const nextMiddleware = nextFactory(context, middleware, 1)
    return middleware[0]({...context, next: nextMiddleware})
  }
  return next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js